import { create } from 'zustand';
import { AuthUtils } from './Auth.utils';
import { WebViewAuthService } from './WebView.auth';

/**
 * Authentication store for managing auth state
 */
const useAuthStore = create<{
  appStarted: boolean;
  isLoggedIn: boolean;
  isWebView: boolean;
  setAppStarted: (appStarted: boolean) => void;
  setIsLoggedIn: (isLoggedIn: boolean) => void;
  handleWebViewToken: (token: string) => void;
}>((set, get) => ({
  // Initial state
  appStarted: AuthUtils.isExpired(),
  isLoggedIn: !AuthUtils.isExpired(),
  isWebView: WebViewAuthService.isWebViewAuthEnabled(),

  // State setters
  setAppStarted: (appStarted: boolean) => set({ appStarted }),
  setIsLoggedIn: (isLoggedIn: boolean) => set({ isLoggedIn }),

  // Handle authentication token from WebView
  handleWebViewToken: (token: string) => {
    // Set the token in AuthUtils
    const authObj = WebViewAuthService.setWebViewAuth(token);
    // Update login state
    set({ isLoggedIn: !AuthUtils.isExpired(authObj) });
  },
}));

export { useAuthStore };
